"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = exports.BadgeListItem = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _tailwind = require("../common/tailwind");
var _consts = require("../utils/layout/consts");
var _BadgeListItem = _interopRequireDefault(require("./BadgeListItem"));
exports.BadgeListItem = _BadgeListItem.default;
const BadgeList = ({
  children,
  dataTest,
  id,
  ariaLabel,
  spacing = _consts.SPACINGS.ONE_HUNDRED
}) => {
  return /*#__PURE__*/React.createElement("ul", {
    className: (0, _clsx.default)("orbit-badge-list m-0 flex flex-col p-0", spacing && (0, _tailwind.getSpacingClasses)(spacing, undefined, "column")),
    "data-test": dataTest,
    id: id,
    "aria-label": ariaLabel
  }, children);
};
var _default = exports.default = BadgeList;